import type { AssetGroup } from '@/types/schemas/nhom-tscd.type';
import type { DataTableColumn } from '@/components/custom/erp';

export const getDataTableColumns = (): DataTableColumn<AssetGroup>[] => [
  {
    field: 'ma_nhom',
    headerName: 'Mã nhóm',
    width: 150,
    flex: 1
  },
  {
    field: 'ten_phan_nhom',
    headerName: 'Tên nhóm',
    width: 200,
    flex: 1
  }
];
